import React from 'react';
import { useDispatch } from 'react-redux';
import { hideChatBot } from '@om/redux/actions/publicWeb/chatBot';
import {
    OmPaginationBlock,
    OmFormDropdownFieldWrapper,
    OmIcon,
    OmButton,
    OmOverlayOpener,
} from '@om/component-library-react';

const PaginationBlock = ({
    slot,
    options,
    currentPaginatedValue,
    numberOfRecords,
    onSelectEventFunction,
    showPrintButton,
    openingOverlayModal,
}) => {

    const dispatch = useDispatch();

    return (
        <OmPaginationBlock slot={slot}>
            <div slot="desktop-pagination-block">
                <div className="bottom-content">
                    <span className="field-label">Rows</span>
                    <div className="range-field">
                        <OmFormDropdownFieldWrapper
                            onOnSelect={(event) => onSelectEventFunction(event)}
                            required={true}
                            formId="table"
                            name="range"
                            align="left"
                            value={currentPaginatedValue}
                            options={JSON.stringify(options)}
                        />
                    </div>
                </div>
                <div className="bottom-content page-number">
                    <strong>{`1-${currentPaginatedValue} of ${numberOfRecords}`}</strong>
                </div>
                {showPrintButton && (
                    <React.Fragment>
                        <div className="bottom-content">
                            <span className="om-download-button">
                                <OmIcon
                                    width="25"
                                    height="25"
                                    iconName="fc_pdf_download"
                                />
                                <OmButton
                                    type="text"
                                    size="small"
                                    text="PRINT OR SAVE TABLE"
                                    onClick={() => {
                                        window.print();
                                    }}
                                />
                                <OmOverlayOpener
                                    onOnOpen={() => dispatch(hideChatBot())}
                                    slot="more-info-button"
                                    openingOverlay={openingOverlayModal}
                                >
                                    <OmIcon
                                        iconName="help_outline"
                                        width="20"
                                        height="20"
                                    />
                                </OmOverlayOpener>
                            </span>
                        </div>
                    </React.Fragment>
                )}
            </div>
            <div slot="mobile-pagination-block">
                <div className="bottom-content">
                    <span className="field-label">Rows</span>
                    <div className="range-field">
                        <OmFormDropdownFieldWrapper
                            onOnSelect={(event) => onSelectEventFunction(event)}
                            required={true}
                            formId="table"
                            name="range"
                            align="left"
                            useNativeMobileDropdown={true}
                            value={currentPaginatedValue}
                            options={JSON.stringify(options)}
                        />
                    </div>
                </div>
                <div className="bottom-content page-number">
                    <strong>{`1-${currentPaginatedValue} of ${numberOfRecords}`}</strong>
                </div>
                {showPrintButton && (
                    <React.Fragment>
                        <div className="download-mobile">
                            <span className="om-download-button">
                                <OmIcon
                                    width="25"
                                    height="25"
                                    iconName="fc_pdf_download"
                                />
                                <OmButton
                                    type="text"
                                    size="small"
                                    text="PRINT OR SAVE TABLE"
                                    onClick={() => {
                                        window.print();
                                    }}
                                />
                                <OmOverlayOpener
                                    onOnOpen={() => dispatch(hideChatBot())}
                                    slot="more-info-button"
                                    openingOverlay={openingOverlayModal}
                                >
                                    <OmIcon
                                        iconName="help_outline"
                                        width="20"
                                        height="20"
                                    />
                                </OmOverlayOpener>
                            </span>
                        </div>
                    </React.Fragment>
                )}
            </div>
        </OmPaginationBlock>
    );
};

export default PaginationBlock;
